import React, { useState, useEffect, useRef } from 'react';
import Basic from '../../Components/Basic/Basic';
import Rightside from '../Customer/Rightside.js';
import MyinvHeader from '../../Components/MyInvestments/MyinvHeader';
import MyinvInvestment from '../../Components/MyInvestments/MyinvInvestment';
import MyinvInterest from '../../Components/MyInvestments/MyinvInterest';
import MyinvDocs from '../../Components/MyInvestments/MyinvDocs';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

import { 
  get_user_accounts, 
  get_user_info, 
  get_account_detail, 
  get_myinvestments, 
  get_general_docs,
} from '../../services/common';
import moment from 'moment';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const MyInvestment = ({ accountSlug: propAccountSlug }) => {
  const systemToken = localStorage.getItem('systemToken') || "";
  
  // Account slug for determining colors (from props, URL params, or default)
  const getAccountSlugFromStorage = () => {
    return window.localStorage.getItem('active_page') || 'my-investment';
  };
  
  // Force my-investment for this component
  const accountSlug = propAccountSlug || 'my-investment';
  
  // Debug: log what accountSlug is being used
  console.log('Current accountSlug:', accountSlug);
  
  // Color mapping based on account slug
  const getAccountColors = (slug) => {
    const colorMap = {
      'paymaster': {
        gradient: 'bg-purple-gradient',
        tailwindGradient: 'from-purple-600 to-pink-200',
        bgClass: 'bg-purple-gradient',
        color: '#7957F5',
        colorName: 'purple',
        textColor: 'text-white',
        isDark: false
      },
      'fum': {
        gradient: 'bg-yellow-gradient', 
        tailwindGradient: 'from-orange-400 to-yellow-500',
        bgClass: 'bg-yellow-gradient',
        color: '#fdad41',
        colorName: 'orange',
        textColor: 'text-white',
        isDark: false
      },
      'securities': {
        gradient: 'bg-black-gradient',
        tailwindGradient: 'from-gray-600 to-gray-700',
        bgClass: 'bg-black-gradient',
        color: '#494949',
        colorName: 'black',
        textColor: 'text-white',
        isDark: true
      },
      'property': {
        gradient: 'bg-brown-gradient',
        tailwindGradient: 'from-amber-700 to-amber-800',
        bgClass: 'bg-brown-gradient',
        color: '#ad8e8e',
        colorName: 'brown',
        textColor: 'text-white',
        isDark: false
      },
      'commodities': {
        gradient: 'bg-blue-gradient',
        tailwindGradient: 'from-blue-400 to-blue-500',
        bgClass: 'bg-blue-gradient',
        color: '#33bfff',
        colorName: 'blue',
        textColor: 'text-white',
        isDark: false
      },
      'custodian': {
        gradient: 'bg-dark-gradient',
        tailwindGradient: 'from-gray-900 to-black',
        bgClass: 'bg-dark-gradient',
        color: '#0a0909',
        colorName: 'dark',
        textColor: 'text-white',
        isDark: true
      },
      'my-investment': {
        gradient: 'bg-gradient-to-r',
        tailwindGradient: 'from-green-500 to-green-400',
        bgClass: 'bg-green-gradient',
        color: '#22b931',
        colorName: 'green',
        textColor: 'text-white',
        isDark: false
      },
      'crypto': {
        gradient: 'bg-crypto',
        tailwindGradient: 'from-indigo-900 to-indigo-950',
        bgClass: 'bg-crypto',
        color: '#08003b',
        colorName: 'black',
        textColor: 'text-white',
        isDark: true
      },
      'private-wealth': {
        gradient: 'bg-crypto',
        tailwindGradient: 'from-indigo-900 to-indigo-950',
        bgClass: 'bg-crypto',
        color: '#08003b',
        colorName: 'black',
        textColor: 'text-white',
        isDark: true
      }
    };
    
    return colorMap[slug] || colorMap['my-investment']; // Default to my-investment colors
  };
  
  const accountColors = getAccountColors(accountSlug);
  
  // State variables
  const [userName, setUserName] = useState('');
  const [userInfo, setUserInfo] = useState({
    user_name: '',
    join_date: '',
    default_currency: 'AUD',
    default_currency_icon: '$'
  });
  const [customerAccounts, setCustomerAccounts] = useState([]);
  const [totalAcBalance, setTotalAcBalance] = useState(0);
  const [totalActiveDefaultBalance, setTotalActiveDefaultBalance] = useState(0);
  const [totalArchiveDefaultBalance, setTotalArchiveDefaultBalance] = useState(0);
  const [defaultCurrencyIcon, setDefaultCurrencyIcon] = useState('$');
  const [defaultCurrency, setDefaultCurrency] = useState('AUD');
  const [subac, setSubac] = useState([]);
  const [selectedSubac, setSelectedSubac] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [docs, setDocs] = useState([]);
  const [docOn, setDocOn] = useState(0);
  const [allTransactions, setAllTransactions] = useState([]);
  const [activeSubac, setActiveSubac] = useState('');
  const [localStorageData, setLocalStorageData] = useState({});
  const [loadOn, setLoadOn] = useState(1);
  
  const [myinvestment, setMyinvestment] = useState({
  
  });
  
  const [allMyinvestments, setAllMyinvestments] = useState([]);
  const [myinvestments, setMyinvestments] = useState([]);
  const [activeMyinvId, setActiveMyinvId] = useState('');
  const [activeTab, setActiveTab] = useState('investment'); // Set default tab

  // Chart state variables
  const [last12Months] = useState([
    moment().subtract(11, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(10, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(9, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(8, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(7, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(6, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(5, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(4, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(3, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(2, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(1, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(0, "month").startOf("month").format('MMM, YYYY'),
  ]);
  const [activeChart, setActiveChart] = useState(1);
  const [onChart, setOnChart] = useState(0);
  // const [chart1, setChart1] = useState([0, 0, 0, 0]);
  // const [chart2, setChart2] = useState([0, 0, 0]);
  // const [chart3, setChart3] = useState([0, 0, 0, 0, 0, 0]);
  // const [chart4, setChart4] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  // const [chart5, setChart5] = useState([0, 0]);

  
  const [chart1, setChart1] = useState([1000, 2000, 1500, 3000]);
  const [chart2, setChart2] = useState([2500, 3000, 3500]);
  const [chart3, setChart3] = useState([4000, 4500, 5000, 5500, 6000, 6500]);
  const [chart4, setChart4] = useState([7000, 7500, 8000, 8500, 9000, 9500, 10000, 10500, 11000, 11500, 12000, 12500]);
  const [chart5, setChart5] = useState([13000, 13500]);


  const STORAGE_KEY = "caprock-local";

  // Chart options
  const chartOptions1 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#22b931',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: ["Week 1", "Week 2", "Week 3", "Week 4"],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#22b931'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };

  

  const chartOptions2 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#22b931',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: [
        moment().subtract(2, "month").startOf("month").format('MMM'),
        moment().subtract(1, "month").startOf("month").format('MMM'),
        moment().subtract(0, "month").startOf("month").format('MMM'),
      ],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#22b931'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };
 

  const chartOptions3 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#22b931',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: [
        moment().subtract(5, "month").startOf("month").format('MMM'),
        moment().subtract(4, "month").startOf("month").format('MMM'),
        moment().subtract(3, "month").startOf("month").format('MMM'),
        moment().subtract(2, "month").startOf("month").format('MMM'),
        moment().subtract(1, "month").startOf("month").format('MMM'),
        moment().subtract(0, "month").startOf("month").format('MMM'),
      ],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#22b931'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };
 
  const chartOptions4 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#22b931',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: last12Months
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#22b931'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };
 

  const chartOptions5 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#22b931',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#22b931'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };
 
  // API functions
  const fetch_user_accounts = async () => {
    try {
      const data = await get_user_accounts(systemToken);
      if (data.success === 200) {
        let totalDBalance = 0;
        setTotalAcBalance(data.t_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setTotalActiveDefaultBalance(0);
        setTotalArchiveDefaultBalance(0);
        
        const acData = data.accounts;
        let totalActive = 0;
        let totalArchive = 0;
        
        for (let i = 0; i < acData.length; i++) {
          if (acData[i].userac_status === 1) {
            totalActive += acData[i].default_currency_balance;
          } else {
            totalArchive += acData[i].default_currency_balance;
          }
          totalDBalance += acData[i].default_currency_balance;
        }
        
        setTotalActiveDefaultBalance(totalActive);
        setTotalArchiveDefaultBalance(totalArchive);
        
        // Calculate percentages
        const accountsWithPercent = acData.map(account => ({
          ...account,
          ac_percent: (100 * account.default_currency_balance / totalActive)
        }));
        
        setCustomerAccounts(accountsWithPercent);
      }
    } catch (error) {
      console.error('Error fetching user accounts:', error);
    }
  };

  const fetch_user_info = async () => {
    try {
      const data = await get_user_info(systemToken);
      
      if (data.success === 200) {
        const userInf = data.profile;
        userInf.join_date = userInf.join_date ? moment(userInf.join_date).format('DD MMM, YYYY') : '';
        setUserInfo(userInf);
        setDefaultCurrency(userInf.default_currency);
        setDefaultCurrencyIcon(userInf.default_currency_icon);
      }
    } catch (error) {
      console.error('Error fetching user info:', error);
      // Set default values if API fails
      setUserInfo({
        user_name: 'Demo User',
        join_date: '01 Jan, 2024',
        default_currency: 'AUD',
        default_currency_icon: '$'
      });
      setDefaultCurrency('AUD');
      setDefaultCurrencyIcon('$');
    }
  };

  const fetch_account_detail = async (ac_name) => {
    try {
      const data = await get_account_detail(systemToken, ac_name || accountSlug);
      
      if (data.success === 200) {
        const myinvestmentData = data.ac_info;
        myinvestmentData.userac_establish_date = moment(myinvestmentData.userac_establish_date).format('DD MMM, YYYY');
        setMyinvestment(myinvestmentData);
        console.log("My investment",myinvestment);
        setSubac(data.ac_data.subaccounts);
        
        // Set active subaccount
        const subII = window.localStorage.getItem('selected_myinvestment_subac_id');
        
        let subId = '';
        if (subII && subII > 0) {
          subId = subII;
        } else if (
          data?.ac_data?.subaccounts &&
          Array.isArray(data.ac_data.subaccounts) &&
          data.ac_data.subaccounts.length > 0
        ) {
          subId = data.ac_data.subaccounts[data.ac_data.subaccounts.length - 1].subac_id;
        } else {
          subId = null; // or handle the "no subaccounts" case here
        }
        setActiveSubac(subId);
        filterTrans(subId);
        
        // Process chart data
        const chartInfo = data.chart_data;
        if (data.chart_data && data.chart_data.length > 0) {
          setChart1(data.chart_data.last_month_chart || []);
          setChart2(data.chart_data.three_month_chart || []);
          setChart3(data.chart_data.six_month_chart || []);
          setChart4(data.chart_data.year_chart ? data.chart_data.year_chart.reverse() : []);
        }
        
        // Process all time chart with proper null checks
        const allChart = chartInfo?.all_chart || [];
        const newChart5 = [];
        const labels = [];
        
        if (allChart && allChart.length === 1) {
          newChart5.push(0);
          labels.push((allChart[0].year - 1));
        }
        
        if (allChart && allChart.length > 0) {
          for (let i = 0; i < allChart.length; i++) {
            newChart5.push(allChart[i].balance);
            labels.push(allChart[i].year);
          }
        }
        
        setChart5(newChart5);
        setOnChart(1);
      }
    } catch (error) {
      console.error('Error fetching account detail:', error);
      // Set default values if API fails
      setMyinvestment({
        ac_balance: 0,
        default_currency_balance: 0,
        userac_name: 'My Investment',
        userac_reference_code: '-',
        userac_establish_date: '--'
      });
      setSubac([]);
      setActiveSubac(1);
      setOnChart(1);
    }
  };

  const fetch_myinvestments = async () => {
    try {
      console.log('Fetching myinvestments with token:', systemToken); // Debug log
      const data = await get_myinvestments(systemToken);
      console.log('Myinvestments response:', data); // Debug log
      
      if (data.success === 200) {
        console.log('Myinvestments data:', data.myinvestments); // Debug log
        setMyinvestments(data.myinvestments);
        
        // If there are investments and no active one is set, select the first one
        if (data.myinvestments && data.myinvestments.length > 0 && !activeMyinvId) {
          const firstInvestment = data.myinvestments[0];
          console.log('Auto-selecting first investment:', firstInvestment); // Debug log
          changeMyinv(firstInvestment.myinvestment_id, 'investment');
        }
      }
    } catch (error) {
      console.error('Error fetching my investments:', error);
    }
  };

  const fetch_general_docs = async (refId, tType, search) => {
    setDocOn(1);
    try {
      const data = await get_general_docs(systemToken, refId, tType, search);
      
      if (data.success === 200) {
        setDocOn(1);
        setDocs(data.docs);
      } else {
        setDocs([]);
      }
    } catch (error) {
      console.error('Error fetching general docs:', error);
      setDocs([]);
    }
  };

  // Event handlers
  const changeMyinv = (myinvId, tab) => {
    console.log('Changing myinv:', myinvId, 'tab:', tab); // Debug log
    
    if (myinvId && myinvId !== '' && myinvId !== 'null') {
      localStorage.setItem('selected_myinv_id', myinvId);
      localStorage.setItem('selected_myinvestment_tab', tab);
      
      setActiveMyinvId(myinvId);
      setActiveTab(tab || 'investment');
    } else {
      setActiveMyinvId('');
      setActiveTab(tab || 'investment');
    }
  };

  const filterTrans = (subacId) => {
    if (typeof subacId !== "undefined" && subacId > 0) {
      localStorage.setItem('selected_myinvestment_subac_id', subacId);
      setActiveSubac(subacId);
      
      const fData = [];
      const tData = subac;
      for (let i = 0; i < tData.length; i++) {
        if (tData[i]['subac_id'] == subacId) {
          fData[i] = tData[i];
        }
      }
      const filteredData = fData.filter(value => Object.keys(value).length !== 0);
      setSelectedSubac(filteredData);
    }
  };

  const showMyinvestmentTrans = (subacId) => {
    setDocOn(0);
  };

  const openLink = (id) => {
    const link = document.getElementById("URL" + id).value;
    window.open(link, '_blank');
  };

  // Lifecycle methods
  useEffect(() => {
    const js = JSON.parse((window.localStorage.getItem(STORAGE_KEY) || "{}"));
    
    if (typeof js !== 'undefined' && typeof js['access-token'] !== 'undefined') {
      setLocalStorageData(js);
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
      // Redirect to sign-in (implement navigation logic)
      console.log('Redirect to sign-in');
    }
    
    document.title = `My Investment || Caprock Merchant Platform`;
    window.localStorage.setItem('active_page', accountSlug);
  }, []);

  useEffect(() => {
    console.log('Component mounted, fetching data...'); // Debug log
    setUserName('');
    fetch_user_accounts();
    fetch_user_info();
    fetch_account_detail(accountSlug);
    fetch_myinvestments();
    
    // Check for stored myinvestment and tab
    const fId = localStorage.getItem('selected_myinv_id');
    const fTab = localStorage.getItem('selected_myinvestment_tab');
    
    console.log('Stored values - fId:', fId, 'fTab:', fTab); // Debug log
    
    if (typeof fId !== 'undefined' && typeof fTab !== 'undefined' && fId && fId !== 'null') {
      setActiveMyinvId(fId);
      setActiveTab(fTab);
      changeMyinv(fId, fTab);
    }
    
    setTimeout(() => setLoadOn(0), 500);
  }, [localStorageData]);

  useEffect(() => {
    console.log('Active Myinv ID:', activeMyinvId); // Debug log
    console.log('Active Tab:', activeTab); // Debug log
  }, [activeMyinvId, activeTab]);

  return (
    <>
      <Basic />
    
      <div className="w-full p-5 mr-80 box-border mt-5">
        <section className="w-full">
          <div className="flex flex-wrap gap-4 mb-6 w-full">
            {/* Left Column - Account Details and Portfolio */}
            <div className="flex-1 min-w-0" style={{ maxWidth: '33.33%' }}>
              {/* Account Details Card */}
              <div className={`bg-gradient-to-br ${accountColors.tailwindGradient} rounded-lg p-4 text-white mb-4`} style={{ minHeight: '300px' }}>
                <div className="flex flex-wrap -mx-4">
                  <div className="w-1/2 px-4">
                    <h5 className="text-white text-sm font-medium mt-1">
                      <b>Account Type</b>
                    </h5>
                    <h5 className="text-white text-xs mt-2">
                      My Investment Management
                    </h5>
                  </div>
                  <div className="w-1/2 px-4">
                    <h5 className="text-white text-sm font-medium mt-1">
                      <b>Balance</b>
                    </h5>
                    <h5 className="text-white text-xs mt-2">
                      {defaultCurrency} {defaultCurrencyIcon}{" "}
                      {myinvestment?.default_currency_balance !== undefined
                        ? myinvestment.default_currency_balance.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        : "0.00"}
                    </h5>

                  </div>
                </div>
                <div className="flex flex-wrap -mx-4 mt-3">
                  <div className="w-1/2 px-4">
                    <h5 className="text-white text-sm font-medium mt-1">
                      <b>Account Name</b>
                    </h5>
                    <h5 className="text-white text-xs mt-2">
                      {myinvestment.userac_name}
                    </h5>
                  </div>
                  <div className="w-1/2 px-4 overflow-y-auto" style={{ maxHeight: '125px' }}>
                    {subac.map((subacItem) => (
                      <h5 key={subacItem.subac_id} className="text-white text-xs mt-2">
                        {subacItem.subac_name}<br />
                        {subacItem.currency_name} {subacItem.currency_symbol}{subacItem.investment_valuation.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </h5>
                    ))}
                  </div>
                </div>
                <div className="flex flex-wrap -mx-4 mt-3">
                  <div className="w-1/2 px-4">
                    <h5 className="text-white text-sm font-medium mt-1">
                      <b>Account Reference</b>
                    </h5>
                    <h5 className="text-white text-xs mt-2">
                      #{myinvestment.userac_reference_code}
                    </h5>
                  </div>
                  <div className="w-1/2 px-4">
                    <h5 className="text-white text-sm font-medium mt-1">
                      <b>Date Account Established</b>
                    </h5>
                    <h5 className="text-white text-xs mt-2">
                      {myinvestment.userac_establish_date}
                    </h5>
                  </div>
                </div>
              </div>

              {/* Portfolio Card */}
              {/* <PortfolioCard
                defaultCurrencyIcon={defaultCurrencyIcon}
                customerAccounts={customerAccounts}
                totalActiveDefaultBalance={totalActiveDefaultBalance}
                defaultCurrency={defaultCurrency}
              /> */}
            </div>

            {/* Right Column - My Investment Details and Chart */}
            <div className="flex-1 min-w-0" style={{ maxWidth: '66.67%' }}>
              {/* My Investment Details */}
              <div className="bg-white rounded-lg mb-4">
                <div className="flex justify-between items-center py-4 px-6 border-b">
                  <div>
                    <h5 className="text-lg font-bold text-gray-700">
                      <b>My Investment Details</b><br />
                      <p className="text-sm text-gray-500" id="transSubTitle"></p>
                    </h5>
                  </div>
                  <div className="w-64">
                    <select 
                      className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                      id="selected_subac_id" 
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        if (selectedId) {
                          changeMyinv(selectedId, 'investment');
                        } else {
                          setActiveMyinvId('');
                          setActiveTab('investment');
                        }
                      }}
                      value={activeMyinvId}
                    >
                      <option value="">Select Myinvestment Account</option>
                      {myinvestments.map((myinv) => (
                        <option key={myinv.myinvestment_id} value={myinv.myinvestment_id}>
                          {myinv.myinv_name} ({myinv.currency_name})
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div className="p-6">
                  {/* Tab Navigation */}
                  <MyinvHeader 
                    myinvId={activeMyinvId}
                    activeTab={activeTab}
                    onTabChange={changeMyinv}
                  />

                  {/* Tab Content */}
                  <div className="min-h-64">
                    {(!activeMyinvId || activeMyinvId === '' || activeMyinvId === null || activeMyinvId === 'null') ? (
                      <div className="text-center py-8">
                        <div className="mb-4">
                          <h3 className="text-lg font-medium text-gray-700 mb-2">No Investment Account Selected</h3>
                          <p className="text-gray-500 mb-4">
                            {myinvestments.length === 0 
                              ? "No investment accounts available. Please contact support if you believe this is an error."
                              : "Please select an investment account from the dropdown above to view records."
                            }
                          </p>
                        </div>
                        
                        {/* Show available investments if any */}
                        {myinvestments.length > 0 && (
                          <div className="max-w-md mx-auto">
                            <h4 className="text-sm font-medium text-gray-600 mb-2">Available Investment Accounts:</h4>
                            <div className="space-y-2">
                              {myinvestments.map((myinv) => (
                                <div 
                                  key={myinv.myinvestment_id} 
                                  className="p-3 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50"
                                  onClick={() => changeMyinv(myinv.myinvestment_id, 'investment')}
                                >
                                  <div className="font-medium text-gray-900">{myinv.myinv_name}</div>
                                  <div className="text-sm text-gray-500">{myinv.currency_name}</div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <>
                        {activeTab === 'investment' && <MyinvInvestment myinvId={activeMyinvId} />}
                        {activeTab === 'interest_payments' && <MyinvInterest myinvId={activeMyinvId} />}
                        {activeTab === 'myinv_loan_note' && <MyinvDocs myinvId={activeMyinvId} docType="myinv_loan_note" />}
                        {activeTab === 'myinv_register' && <MyinvDocs myinvId={activeMyinvId} docType="myinv_register" />}
                        {activeTab === 'docs' && <MyinvDocs myinvId={activeMyinvId} docType="docs" />}
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* Chart Section */}
              <div className="bg-white rounded-lg">
                <div className="border-b">
                  <div className="flex justify-between items-center py-2 px-6">
                    <ul className="flex space-x-8">
                      <li>
                        <button 
                          onClick={() => setActiveChart(1)} 
                          className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                            activeChart === 1 
                              ? 'text-green-500 border-green-500' 
                              : 'text-gray-500 border-transparent hover:text-gray-700'
                          }`}
                        >
                          <b>Last Month</b>
                        </button>
                      </li>
                      <li>
                        <button 
                          onClick={() => setActiveChart(2)} 
                          className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                            activeChart === 2 
                              ? 'text-green-500 border-green-500' 
                              : 'text-gray-500 border-transparent hover:text-gray-700'
                          }`}
                        >
                          <b>3M</b>
                        </button>
                      </li>
                      <li>
                        <button 
                          onClick={() => setActiveChart(3)} 
                          className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                            activeChart === 3 
                              ? 'text-green-500 border-green-500' 
                              : 'text-gray-500 border-transparent hover:text-gray-700'
                          }`}
                        >
                          <b>6M</b>
                        </button>
                      </li>
                      <li>
                        <button 
                          onClick={() => setActiveChart(4)} 
                          className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                            activeChart === 4 
                              ? 'text-green-500 border-green-500' 
                              : 'text-gray-500 border-transparent hover:text-gray-700'
                          }`}
                        >
                          <b>Year</b>
                        </button>
                      </li>
                      <li>
                        <button 
                          onClick={() => setActiveChart(5)} 
                          className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                            activeChart === 5 
                              ? 'text-green-500 border-green-500' 
                              : 'text-gray-500 border-transparent hover:text-gray-700'
                          }`}
                        >
                          <b>All</b>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="p-6">
                  {onChart === 1 ? (
                    <div className="h-80 flex items-center justify-center">
                    {activeChart === 1 && <Line data={{ labels: ["Week 1", "Week 2", "Week 3", "Week 4"], datasets: [{ label: 'Balance', data: chart1, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions1} />}
                    {activeChart === 2 && <Line data={{ labels: ["Month 1", "Month 2", "Month 3"], datasets: [{ label: 'Balance', data: chart2, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions2} />}
                    {activeChart === 3 && <Line data={{ labels: ["Month 1", "Month 2", "Month 3", "Month 4", "Month 5", "Month 6"], datasets: [{ label: 'Balance', data: chart3, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions3} />}
                    {activeChart === 4 && <Line data={{ labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], datasets: [{ label: 'Balance', data: chart4, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions4} />}
                    {activeChart === 5 && <Line data={{ labels: ["Year 1", "Year 2"], datasets: [{ label: 'Balance', data: chart5, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions5} />}      
                    </div>
              
                  ) : (
                    <div className="h-64 flex items-center justify-center bg-gray-50 rounded border-2 border-dashed border-gray-300">
                      <span className="text-gray-500">Loading...</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default MyInvestment;
